import moment from "moment";
import React from "react";
import Constants from "../data/Constants";
import { IconButton } from "@mui/material";
import { MdDelete } from "react-icons/md";
function Coupon({ coupon, onClick, onDelete }) {
  const disabledClass =
    !coupon.code || moment(coupon.expiredAt).isBefore() ? " grayscale" : "";
  return (
    <div
      className={
        "w-full md:w-auto p-5 bg-blue-100 m-2 border-4 border-dotted border-primary cursor-pointer hover:scale-105 hover:border-primaryDark transition-all relative" +
        disabledClass
      }
      onClick={onClick}
    >
      <div className="absolute right-0 bottom-0 translate-x-3 translate-y-3 bg-primary rounded-full z-10">
        <IconButton size="small" sx={{ opacity: 1 }} onClick={onDelete}>
          <MdDelete color="white" />
        </IconButton>
      </div>
      <h1 className="text-lg font-extrabold text-center text-primaryDark">
        {coupon.code}
      </h1>
      <div className="text-sm my-3">
        {console.log(coupon)}
        {coupon.fixedDiscount != null &&
          "Fixed Discount: " + Constants.CURRENCY_SYMBOL + coupon.fixedDiscount}
        {coupon.percentageDiscount != null &&
          "Percentage Discount: " + coupon.percentageDiscount + "%"}
      </div>

      <div className="text-sm">Max Amount: {coupon.maxAmount || "Not Set"}</div>
      <div className="text-sm">Min Amount: {coupon.minAmount || "Not Set"}</div>
      <div className="text-sm">
        Expiry:{" "}
        {coupon.expiredAt ? moment(coupon.expiredAt).fromNow() : "Never"}
      </div>
    </div>
  );
}

export default Coupon;
